"use strict";

var LoggerInstance = require("js-logger").get("CategoryActions");

var ActionsHelper = require("../actions/ActionsHelper");
var ProductActions = require("../actions/ProductActions");

var Constants = require("../designer/Constants");

var GridListToggleHelper = require("../designer/components/searchResults/GridListToggleHelper");

var Dispatcher = require("../dispatcher/Dispatcher");

var ProjectActions = require("../projectComponents/ProjectActions");

var HistoryHelper = require("../shared/HistoryHelper");

var CategoryActions = {
	initializeGridListToggle: function(id, previouslySelectedView) {
		GridListToggleHelper.initializeGridListToggle(id, previouslySelectedView, "category", "grid-category-items-wrapper", "list-category-items-wrapper");
	},

	initializeStore: function (options) {
		var action = Object.assign({}, options, { actionType: Constants.CATEGORY_INITIALIZE });
		Dispatcher.dispatch(action);
	},

	navigateToCategory: function (isDesignMode, categoryUrl) {
		if (isDesignMode) {
			return;
		}
		window.location = categoryUrl;
	},

	navigateToTangible: function (isDesignMode, tangibleUrl) {
		if (isDesignMode) {
			return;
		}
		window.location = tangibleUrl;
	},

	addToCart: function (isDesignMode, tangibleType, tangibleCode, addAndStay, event) {
		try {
			event = ActionsHelper.getEventOrReturn(event, isDesignMode, "Category Navigate or Add To Cart called successfully.", /*preventDefaultInDesignMode*/false);
			if (!event) {
				return;
			}

			var afterSubmit = () => {
				if (!addAndStay) {
					window.location = "/shoppingcart";
				}
			};

			var $item = $(event.target).closest("[data-component=category],[data-component=carousel]");
			var dataComponent = $item.attr("data-component");
			var categoryId = $item.attr("id");
			var context = `${dataComponent}_${categoryId}`;
			switch (tangibleType) {
				case "PRODUCTS":
					ProductActions.addToCart(event, context, tangibleCode, afterSubmit);
					break;
				case "PROJECTS":
					ProjectActions.addToCart(event, context, tangibleCode, afterSubmit);
					break;
			}
		}
		catch(exception) {
			LoggerInstance.error(exception);
		}
		finally {
			return false;
		}
	},

	handlePopState: function (event) {
		HistoryHelper.handlePopState(/*executeAction*/ (currentQueryObject, additionalOptions) => {
			window._categorySearch(/*categoryComponentId*/null, /*page*/null, /*sort*/null, additionalOptions);
		});
	},

	purgeHistoryState(queryObjectsToDelete, updateId) {
		if (!window.isCategoryPage) {
			//If we are not on the category page, we do not want to update the History
			return;
		}

		HistoryHelper.purgeHistoryState();
	},

	updateHistoryStateAfterLoad: function (newQueryObject, updateId) {
		if (!window.isCategoryPage) {
			//If we are not on the category page, we do not want to update the History
			return;
		}

		HistoryHelper.updateHistoryStateAfterLoad(newQueryObject, updateId);
	}
};

module.exports = CategoryActions;
